import React from 'react';

// library
import { Spinner } from '@interstate/components/Spinner';

// style
import { Overlay, OverlayContent } from './LoadingSection.style';

// types
import type { IOverlayProps } from './LoadingSectionTypes';

const id = 'loading-section';

/**
 * Simple loading indicator element that blocks the sibling content below it with a translucent background
 * Must have a LoadingSectionParent element as its direct parent element
 */
const LoadingSection = ({ loading, testId, opacity, size }: IOverlayProps) => {
    return (
        <Overlay loading={loading} data-testid={testId || id} opacity={opacity}>
            <OverlayContent>
                <Spinner size={size ?? 60} data-testid={`ids-spinner-root-payment-${id}`} />
            </OverlayContent>
        </Overlay>
    );
};

export default LoadingSection;
